import { gql } from '@apollo/client/index.js'
import { useContentful } from '@ecomm/shared-apollo'
import { useMemo } from 'react'
import { apolloColoredSectionSchema } from './schema'

const DEFAULT_COLORED_SECTION_QUERY = gql`
  fragment button on Button {
    sys {id}
    id : sys {id}
    __typename
    buttonText: text
    url
    type
  }

  query	Colored_Section_Query($id: String!, $preview: Boolean!, $locale: String!) {
    coloredSection(id: $id, locale: $locale, preview: $preview) {
      headline
      theme
      __typename
      sys { id }
      id: sys { id }
    	disclaimer {
        json
      }
    	contentCollection(limit: 10) {
        items {
          ... on Text {
            text {
              json
              links {
                entries {
                  block {
                    ... on IconAndText {
                      __typename
                      id: sys {id}
                      sys {id}
                      text { json }
                      icon
                    }
                    ... on Button {
                      ...button
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
export const useColoredSectionQuery = (
  id: string,
  QUERY = DEFAULT_COLORED_SECTION_QUERY
) => {
  const { data: apolloData } = useContentful(QUERY, {
    id
  })

  const coloredSectionData = useMemo(
    () => apolloColoredSectionSchema.parse(apolloData?.['coloredSection']),
    [apolloData]
  )

  return coloredSectionData
}
